module.exports = __webpack_public_path__ + "img/head_left.868e204b.png";